import React from "react";
import { glassCard } from "../../../helpers/Executive-Dashboard/styleFormat";

const labelStyle = { fontSize: '11px', fontWeight: '600', color: '#94a3b8', display: 'block', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' };
const bigNum = { fontSize: '22px', fontWeight: '800', color: '#0f172a', letterSpacing: '-0.5px' };

export const KPICard = React.memo(({ label, value, sub, color, icon }) => (
    <div style={{ ...glassCard, padding: '16px 18px', borderLeft: `4px solid ${color}`, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
            <span style={labelStyle}>{label}</span>
            <div style={bigNum}>{value}</div>
            {sub && <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{sub}</div>}
        </div>
        <span style={{ fontSize: '24px', opacity: 0.7, color: color }}>{icon}</span>
    </div>
));